import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useStreamPlaceHolderStyles } from 'newhooks/sportsbook/matchStreaming/useStreamPlaceHolderStyles';
import './index.less';

type TStreamCourtSkeletonProps = {
  classNames?: string;
};

export const StreamCourtSkeleton = ({
  classNames
}: TStreamCourtSkeletonProps): ReactElement | null => {
  const streamPlaceHolderStyles = useStreamPlaceHolderStyles();

  return (
    <div
      style={streamPlaceHolderStyles}
      className="streamCourtSkeleton__container"
    >
      <div className={`streamCourtSkeleton ${classNames || ''}`}>
        <Skeleton
          className="streamCourtSkeleton__background"
          round={false}
          paragraph={false}
          active
        />
      </div>
    </div>
  );
};
